import { allowedAdmissionStatus } from '@/utils/constants/admission.constants';

export default {
  allowedAdmissionStatus() {
    return allowedAdmissionStatus.map((item) => item.status).join();
  },
  haveScheduledExams({ data }) {
    let haveScheduledExams = false;
    if (data.medicalOrders && data.medicalOrders.length) {
      haveScheduledExams = !!data.medicalOrders[0].exams?.length;
    }

    return {
      status: haveScheduledExams,
      label: haveScheduledExams ? 'agendado' : 'nao-agendado',
    };
  },
  getAdmissionQuestions({ data }) {
    const { questions } = data;
    return questions;
  },

  backOfficeDone({ data }) {
    return data.backOfficeDone;
  },

  getCurrentAdmissionState(state) {
    return state;
  },

  getMedicalOrders({ data }) {
    return data.medicalOrders;
  },
};
